import React from "react";
import "../KVKK/KVKK.css";

const GizlilikSozlesmesi = () => {
  return (
    <div className="kvkk-page">
      <section className="kvkk-hero">
        <h1>Gizlilik <span>Sözleşmesi</span></h1>
      </section>

      <div className="kvkk-content">
        <div className="kvkk-container">
          <table className="kvkk-info-table">
            <tbody>
              <tr><td>Veri Sorumlusu</td><td>Lingify Sağlık Teknolojileri A.Ş.</td></tr>
              <tr><td>Adres</td><td>Reşitpaşa Mah. Katar Cad. İTÜ ARI Teknokent 3 Binası No: 4/B204 Sarıyer/İstanbul</td></tr>
              <tr><td>MERSİS</td><td>0608171176500001</td></tr>
              <tr><td>E-posta</td><td>info@lingify.co</td></tr>
            </tbody>
          </table>

          <h2>1. Giriş</h2>
          <p>Lingify Sağlık Teknolojileri A.Ş. ("Lingify") olarak, www.lingify.co web sitesi ve ilgili hizmetlerimizi kullanan ziyaretçilerimizin gizliliğini korumayı taahhüt ediyoruz.</p>

          <h2>2. Toplanan Veriler</h2>
          <p><strong>Doğrudan sağladığınız veriler:</strong> Ad-soyad, e-posta adresi, form mesajları, profesyonel bilgiler.</p>
          <p><strong>Otomatik toplanan veriler:</strong> IP adresi, tarayıcı türü, ziyaret edilen sayfalar (yalnızca zorunlu teknik çerezler aracılığıyla).</p>

          <h2>3. Verilerin Kullanım Amaçları</h2>
          <ul>
            <li>Hizmetlerimizi sunmak ve geliştirmek</li>
            <li>Kullanıcı destek taleplerini yanıtlamak</li>
            <li>Topluluk etkinlikleri hakkında bilgilendirme yapmak</li>
            <li>Site güvenliğini sağlamak</li>
          </ul>

          <h2>4. Çerez Politikası</h2>
          <p>Sitemizde yalnızca zorunlu teknik çerezler kullanılmaktadır. Detaylar için <a href="/cerez-politikasi">Çerez Politikası</a> sayfamızı ziyaret edin.</p>

          <h2>5. Veri Paylaşımı</h2>
          <p>Kişisel verileriniz yalnızca hosting/altyapı sağlayıcıları ve yasal zorunluluk halinde yetkili kurumlarla paylaşılır.</p>

          <h2>6. Veri Güvenliği</h2>
          <p>SSL şifreleme, güvenli sunucular ve erişim kontrolü gibi teknik tedbirler uygulanmaktadır.</p>

          <h2>7. Haklarınız</h2>
          <p>KVKK kapsamında verilerinize erişme, düzeltme, silme ve itiraz etme haklarına sahipsiniz. Detaylı bilgi için <a href="/kvkk">KVKK Aydınlatma Metni</a> sayfamızı ziyaret edin.</p>

          <h2>8. İletişim</h2>
          <p>E-posta: <a href="mailto:info@lingify.co">info@lingify.co</a></p>
        </div>
      </div>
    </div>
  );
};

export default GizlilikSozlesmesi;
